import { useTranslation } from 'next-i18next'
import styles from './CarModel.module.scss'
import React from 'react'

type Props = {
  carModel: string
  licensePlate: string
}

const CarModel = (props: Props) => {
  const { t } = useTranslation(['cart'])

  if (!props.carModel)
    return null

  return (
    <div className={styles.component}>
      {props.licensePlate && (
        <>
          <label>{t('cart:licensePlate')}:</label> {props.licensePlate}
        </>
      )}
      <label>{t('cart:carModel')}:</label> {props.carModel}
    </div>
  )
}

export default CarModel